import { render, staticRenderFns } from "./OperationRecord.vue?vue&type=template&id=5318914e&scoped=true&"
import script from "./OperationRecord.vue?vue&type=script&lang=js&"
export * from "./OperationRecord.vue?vue&type=script&lang=js&"
import style0 from "./OperationRecord.vue?vue&type=style&index=0&id=5318914e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318914e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5318914e')) {
      api.createRecord('5318914e', component.options)
    } else {
      api.reload('5318914e', component.options)
    }
    module.hot.accept("./OperationRecord.vue?vue&type=template&id=5318914e&scoped=true&", function () {
      api.rerender('5318914e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OperationRecord.vue"
export default component.exports